<div class="container mx-auto m">
  <p-carousel
    class="block -ml-6 -mr-4"
    [value]="lotteriesCarouselData()"
    [numVisible]="1.5"
    [numScroll]="1"
    [showIndicators]="false"
    [autoplayInterval]="lotteryCarousel() === 'animated' ? 3500 : undefined"
  >
    <ng-template let-lottery pTemplate="item">
      <article class="rounded-border bg-white drop-shadow max-w-full m-1 overflow-hidden relative">
        <div>
          <img
            height="120px"
            class="object-cover h-[120px] w-full"
            [alt]="lottery.name"
            [homeyImage]="'small-header'"
            [homeyImageSrc]="lottery.image"/>
        </div>
        @if (link()) {
          <a [routerLink]="apartmentRoute() | combineArrays: [lottery.slug ?? lottery.id]" [queryParams]="queryParams()"
           class="fit-to-container">
          <span class="sr-only">
            {{ lottery.name }}
          </span></a>
        }
        <div class="max-w-full relative" [ngClass]="{
        'h-[4.5rem]': showPrice(),
        'h-[3.6rem]': !showPrice()
        }">
          <div class="absolute left-0 right-0 top-0 bottom-0 p-1">
            <p class="text-xs font-bolder truncate">
              {{ lottery.name }}
            </p>
            <p class="text-xs text-surface-500 truncate">
              {{ lottery| apartmentAddress }}
            </p>
            <p class="text-xs text-surface-500 truncate">
              {{ 'apartment.carousel.lotteryCloses' | transloco : { date: (lottery.endDate | date: 'MMM d') } }}
              @if (showPrice()) {
            <p class="text-xs font-medium">
              <homey-rent-display
                [relevantAdvertisementsInput]="relevantApartmentsInput()"
                [advertisements]="lottery"
              />
            </p>
              }
          </div>
        </div>
      </article>
    </ng-template>
  </p-carousel>
</div>
